import React from 'react'

function CrewCall() {
    return (
        <div className='crew__call'>
            <span className='box1__pick-number'>02</span><span className='box1__pick-title'>Meet your crew</span>
        </div>
    )
}

export default CrewCall